import * as Managers from "./Exporters/ManagerExporter";

import { registerLicense } from '@syncfusion/ej2-base';


export class App {

    public static SideBar : Managers.SideBarManager;

    constructor() {
        $(document).ajaxComplete(function (event, xhr, settings) { $('button').blur(); });

        registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfeXRQRmZcU0N0XEI=');

        $('#sidebar').each((index, element) => {
            App.SideBar = new Managers.SideBarManager($(element));
            App.SideBar.initialize();
        });

        $('#company-index-container').each((index, element) => {
            new Managers.CompanyIndexManager($(element)).initialize();
        });          
        
        $('#company-details-container').each((index, element) => {
            new Managers.CompanyDetailManager($(element)).initialize();
        });  
    }
}